import React from "react";
import ImageContainer from "../core/ImageContainer";
import { Link } from "react-router-dom";

const NewsOverview = ({ time, id, title, img, content, author, url_override, status }) => {

  if (status !== 1) return null

  return (
    <Link
      to={url_override ? url_override : `/news/${id}` }
      className="group dark:border-0 border-2 border-light-3 md:h-40 flex flex-col md:flex-row justify-between rounded-lg mb-4 bg-light-1 dark:bg-dark-4 pr-4"
      target={url_override ? "_blank" : ""}
    >
      <div className="flex flex-row justify-between w-full">
        <div className="h-40 w-48 md:w-64 mr-2 xxs:mr-4 relative top-0 left-0 overflow-hidden">
          {/* Image */}
          <img
              src={img ? `https://buiha.org.uk/assets/img/resource/${img}` : "/placeholder2.jpg"}
              alt={title}
              className="h-full w-full object-cover relative top-0 left-0"
          />
          {img ? null : <img
              src={`https://buiha.org.uk/assets/img/icon/md/${author.toLowerCase()}.png`}
              alt={title}
              className="absolute top-0 left-0 opacity-30"
          />}
        </div>
        <div className="flex flex-col items-start justify-between w-full">
          <div className="flex flex-col">
            {/* Title and time posted */}
            <p className="pt-1 dark:pt-0 font-semibold text-lg xs:text-xl transition-colors duration-300 ease-in-out group-hover:text-buiha-red dark:group-hover:text-dark-5">
              {title}
            </p>
            <p className="text-darken hidden md:flex text-xs">
              {"Posted " + time + " ago"}
            </p>
          </div>
          <p className="hidden xs:flex text-xs pr-4 pt-2 pb-4">
            {content.length > 250
              ? content.substring(0, 250) + "..."
              : content}
          </p>
          {/* Content - cut based on chars */}
          <p className="xs:hidden text-xxs xs:text-xs pr-4 pt-2 pb-4">
            {content.length > 100
              ? content.substring(0, 50) + "..."
              : content}
          </p>
        </div>
      </div>
    </Link>
  );
};

export default NewsOverview;
